export enum InvoiceStatus {
  Draft,
  Open,
  Paid,
  Uncollectible,
  Void,
}
